import styles from './LK.module.css'
import LeftSideMenu from "../LeftSideMenu/LeftSideMenu";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import React from "react";
import SimWork from "./SimWork/SimWork";
import ExcelWorkOne from "./ExcelWorkOne/ExcelWorkOne";
import CoreOperation from "./CoreOperation/CoreOperation";
import SimBan from "./SimBan/SimBan";
import SysOption from "./SysOption/SysOption";
import PayList from "./PayList/PayList";
import VolumeList from "./VolumeList/VolumeList";
import DeliveryList from "./Delivery/DeliveryList";
import DeliverySend from "./DeliverySend/DeliverySend";
export default function Lk()
{
    return(
        <div>
            <LeftSideMenu>
                <Routes>
                    <Route path='/sim' element={<SimWork></SimWork>} />
                    <Route path='/ban' element={<SimBan></SimBan>} />
                    <Route path='/excel/one' element={<ExcelWorkOne></ExcelWorkOne>} />
                    <Route path='/operation' element={<CoreOperation></CoreOperation>} />
                    <Route path='/option' element={<SysOption></SysOption>} />
                    <Route path='/pay/list' element={<PayList></PayList>} />
                    <Route path='/volume/list' element={<VolumeList></VolumeList>} />

                    <Route path='/delivery/list' element={<DeliveryList></DeliveryList>} />
                    <Route path='/delivery/send' element={<DeliverySend></DeliverySend>} />

                </Routes>
            </LeftSideMenu>
        </div>
    );
}